class CentrosAccordion {
  constructor () {
    this.init()
  }

  init () {
    const accordions = document.querySelectorAll('.c-red_centros')

    if (!accordions) return
    accordions.forEach((accordion) => {
      const openCloseButton = accordion.querySelector('.c-red_centros__toggleAll')
      const accordionItems = accordion.querySelectorAll('.c-red_centros__item')

      if (!openCloseButton || !accordionItems) return
      openCloseButton.addEventListener('click', () => {
        if (openCloseButton.classList.contains('hasAllOpened')) {
          accordionItems.forEach(item => {
            this.closeAccordionItem(item)
          })
          openCloseButton.classList.remove('hasAllOpened')
          openCloseButton.classList.add('hasAllClosed')
        } else {
          accordionItems.forEach(item => {
            this.openAccordionItem(item)
          })
          openCloseButton.classList.remove('hasAllClosed')
          openCloseButton.classList.add('hasAllOpened')
        }
      })

      accordionItems.forEach(item => {
        this.closeAccordionItem(item)
        item.addEventListener('click', () => {
          if (item.classList.contains('isOpen')) {
            this.closeAccordionItem(item)
          } else {
            this.openAccordionItem(item)
          }
        })
      })
    })
  }

  openAccordionItem (item) {
    const content = item.querySelector('.c-featuredAccordion__itemContent')
    if (content) {
      item.classList.add('isOpen')
      content.style.maxHeight = content.scrollHeight + 'px'
      content.style.opacity = '1'
    }
  }

  closeAccordionItem (item) {
    const content = item.querySelector('.c-featuredAccordion__itemContent')
    if (content) {
      content.style.maxHeight = content.scrollHeight + 'px'
      content.style.opacity = '0'
      content.style.maxHeight = '0px'
      content.addEventListener('transitionend', function onTransitionEnd () {
        item.classList.remove('isOpen')
        content.removeEventListener('transitionend', onTransitionEnd)
      })
    }
  }
}

export default CentrosAccordion
